import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog } from '@linktivity/link-ui';
import Login from '@link/share/views/Login';
import { IDialogLoginProps } from './DialogLogin.types';

const DialogLogin = observer(
  ({ visible, onClose, auth, firebase, onLoginSuccess }: IDialogLoginProps) => {
    useEffect(() => {
      if (visible && auth.loggedIn) {
        onLoginSuccess?.();
      }
    }, [visible, auth.loggedIn, onLoginSuccess]);

    return (
      <Dialog visible={visible} onClose={onClose}>
        <Login auth={auth} firebase={firebase} />
      </Dialog>
    );
  }
);

export default DialogLogin;
